import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../ui/dialog';
import { LeadForm } from './LeadForm';
import { Sparkles } from 'lucide-react';

export const AuditModal = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-lg bg-white rounded-2xl" data-testid="audit-modal">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 bg-[#FFAA17]/10 rounded-full flex items-center justify-center">
              <Sparkles className="w-6 h-6 text-[#FFAA17]" />
            </div>
            <div>
              <DialogTitle className="text-2xl font-bold text-[#1A1A1A]">
                Free Growth Audit
              </DialogTitle>
              <DialogDescription className="text-[#525252]">
                Get a personalized growth strategy for your business
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="mt-4">
          <div className="bg-[#27AE60]/5 border border-[#27AE60]/20 rounded-xl p-4 mb-6">
            <p className="text-sm text-[#1A1A1A] font-medium mb-2">
              What you'll get:
            </p>
            <ul className="space-y-1.5 text-sm text-[#525252]">
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-[#27AE60] rounded-full"></span>
                Website & SEO analysis
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-[#27AE60] rounded-full"></span>
                Competitor insights
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-[#27AE60] rounded-full"></span>
                Custom growth recommendations
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-[#27AE60] rounded-full"></span>
                30-minute strategy call
              </li>
            </ul>
          </div>

          <LeadForm 
            source="growth_audit" 
            compact={true}
            onSuccess={() => {
              setTimeout(() => {
                onClose();
              }, 3000);
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AuditModal;
